// Load Styles
import "../scss/main.scss";
import $ from "jquery";
import "slick-carousel";

// Load Bootstrap init
import { initBootstrap } from "./bootstrap";

// Loading bootstrap with optional features
initBootstrap({
  tooltip: true,
  popover: true,
  toasts: true
});

// Load Google Fonts

var WebFont = require("webfontloader");

WebFont.load({
  google: {
    families: ["Montserrat"]
  }
});

window.onscroll = function () {
  myFunction();
};

// Get the header
var header = document.getElementById("myHeader");

// Get the offset position of the navbar
var sticky = header.offsetTop + 100;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.scrollY > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

$(function () {
  console.log("ready!");
});
$(".customer-logos").slick(
  {
    slidesToShow: 6,
    rows: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    speed: 3500,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          rows: 2
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 2,
          rows: 2
        }
      }
    ]
  },
  5000
);

$(".awards__wrapper").slick(
  {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          rows: 1
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 2,
          rows: 1
        }
      }
    ]
  },
  5000
);

var $cell = $(".card");

//open and close card when clicked on card
$cell.find(".js-expander").click(function () {
  var $thisCell = $(this).closest(".card");

  if ($thisCell.hasClass("is-collapsed")) {
    $cell.not($thisCell).removeClass("is-expanded").addClass("is-collapsed").addClass("is-inactive");
    $thisCell.removeClass("is-collapsed").addClass("is-expanded");

    if ($cell.not($thisCell).hasClass("is-inactive")) {
      //do nothing
    } else {
      $cell.not($thisCell).addClass("is-inactive");
    }
  } else {
    $thisCell.removeClass("is-expanded").addClass("is-collapsed");
    $cell.not($thisCell).removeClass("is-inactive");
  }
});

//close card when click on cross
$cell.find(".js-collapser").click(function () {
  var $thisCell = $(this).closest(".card");

  $thisCell.removeClass("is-expanded").addClass("is-collapsed");
  $cell.not($thisCell).removeClass("is-inactive");
});

$(function () {
  $("#siteFooter h5").on("click", function (e) {
    e.stopPropagation();
    $(this).parent(".footer-nav").toggleClass("open");
  });
});
